// components/superadmin/CreateAdminForm.jsx
import { useState } from "react";
import { toast } from "sonner"; // you can even remove this and use alert()
import { UserPlus, Shield, Mail, Lock } from "lucide-react";

export default function CreateAdminForm() {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "admin12345"
  });

  const handleCreateAdmin = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email) {
      toast?.error("Name and Email are required!") || alert("Name and Email required!");
      return;
    }
    setLoading(true);

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}superadmin/create-admin`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`
        },
        body: JSON.stringify(form)
      });
      const data = await res.json();

      if (data.success) {
        toast?.success(`Admin "${form.name}" created!`) || alert("Admin created!");
        setForm({ name: "", email: "", password: "admin12345" });
      } else {
        toast?.error(data.message) || alert(data.message);
      }
    } catch (err) {
      toast?.error("Network error") || alert("Network error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto mt-10 bg-white rounded-xl shadow-2xl border border-purple-200 overflow-hidden">
      {/* Header */}
      <div className="bg-gradient-to-r from-purple-600 to-pink-600 text-white p-6">
        <h2 className="text-2xl font-bold flex items-center gap-3">
          <Shield className="w-8 h-8" />
          Create New Admin
        </h2>
        <p className="mt-1 opacity-90">Only SuperAdmin fit use this power ⚡</p>
      </div>

      {/* Body */}
      <div className="p-8">
        <form onSubmit={handleCreateAdmin} className="space-y-6">
          {/* Name */}
          <div>
            <label className="flex items-center gap-2 text-lg font-medium text-gray-700">
              <UserPlus className="w-5 h-5" />
              Full Name
            </label>
            <input
              type="text"
              placeholder="e.g. Chinedu Okonkwo"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              required
              className="mt-2 w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-4 focus:ring-purple-300 focus:border-purple-500 outline-none transition"
            />
          </div>

          {/* Email */}
          <div>
            <label className="flex items-center gap-2 text-lg font-medium text-gray-700">
              <Mail className="w-5 h-5" />
              Email Address
            </label>
            <input
              type="email"
              placeholder="admin@jobplartform.com"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              required
              className="mt-2 w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-4 focus:ring-purple-300 focus:border-purple-500 outline-none transition"
            />
          </div>

          {/* Password */}
          <div>
            <label className="flex items-center gap-2 text-lg font-medium text-gray-700">
              <Lock className="w-5 h-5" />
              Default Password
            </label>
            <div className="mt-2 bg-gray-100 p-4 rounded-lg font-mono text-lg font-bold text-purple-700">
              {form.password}
            </div>
            <p className="text-sm text-gray-600 mt-2">Admin go change am after first login</p>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white font-bold text-xl py-5 rounded-lg flex items-center justify-center gap-2 disabled:opacity-70 transition"
          >
            {loading ? "Creating..." : <><UserPlus /> Create Admin Account</>}
          </button>
        </form>

        {/* Info Box */}
        <div className="mt-8 p-5 bg-yellow-50 border border-yellow-300 rounded-lg">
          <p className="font-bold text-yellow-800">After creation:</p>
          <ul className="text-sm text-yellow-700 mt-2 space-y-1">
            <li>→ Send login details give the new admin</li>
            <li>→ Dem go use email + "admin12345" first time</li>
            <li>→ Make dem change password sharp sharp!</li>
          </ul>
        </div>
      </div>
    </div>
  );
}